const themeNames = ['morning', 'dawn', 'midday', 'dusk', 'midnight'] as const;

export default themeNames;
